import React from 'react';
import { CustomizerProvider } from './context';
import Court from './court';
import MvpBar from './bar-mvp';

const Context = ({ children }) => {
  return <CustomizerProvider>{children}</CustomizerProvider>;
};

const Game = {
  Container: props => <Context {...props} />,
  Court: props => <Court {...props} />,
  MvpBar: props => <MvpBar {...props} />,
};
export default Game;
